import { session } from 'wix-storage';

const editorxSessionIdKey = 'editorx.intro.sessionId';

class Storage {
    constructor() {
        this.sessionId = session.getItem(editorxSessionIdKey) || generateSessionId();
        session.setItem(editorxSessionIdKey, this.sessionId);
    }
	getSessionId() {
        return this.sessionId;
    }
}

function generateSessionId() {
	return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
		const r = Math.random() * 16 | 0,
			v = c === 'x' ? r : (r & 0x3 | 0x8); // eslint-disable-line
		return v.toString(16);
	});
}

const storage = new Storage();
export default storage;